import {ImageRequireSource} from 'react-native';

const DICE_GAME_ICON: Record<number, ImageRequireSource> = {
  1: require('./dice/dice-1.webp'),
  3: require('./dice/dice-3.webp'),
  5: require('./dice/dice-5.webp'),
  15: require('./dice/dice-15.webp'),
};

const COLOR_GAME_ICON: Record<number, ImageRequireSource> = {
  1: require('./color/color-1.webp'),
  2: require('./color/color-2.webp'),
  3: require('./color/color-3.webp'),
  5: require('./color/color-5.webp'),
};

const KERALA_GAME_ICON: Record<string, ImageRequireSource> = {
  AKSHAYA: require('./kerala/akshaya.webp'),
  'STHREE-SAKTHI': require('./kerala/sthree.webp'),
  KARUNYA: require('./kerala/karunya.webp'),
  NIRMAL: require('./kerala/nirmal.webp'),
  'KARUNYA PLUS': require('./kerala/karunya-plus.webp'),
  'FIFTY-FIFTY': require('./kerala/fifty.webp'),
  'WIN-WIN': require('./kerala/win.webp'),
  'ONLINE-ONLY': require('./kerala/only.webp'),
};

const SATTA_GAME_ICON: Record<string, ImageRequireSource> = {
  Kalyan: require('./satta/kalyan.webp'),
  'Kalyan Night': require('./satta/kalyan-night.webp'),
  'Milan Night': require('./satta/milan-night.webp'),
  'Main Bazar': require('./satta/main-bazar.webp'),
  'Mumbai Main': require('./satta/mumbai-main.webp'),
  'Bengal Bazar': require('./satta/bengal-bazar.webp'),
  Ratnagiri: require('./satta/ratnagiri.webp'),
  'Kalyan Morning': require('./satta/kalyan-morning.webp'),
  'Milan Morning': require('./satta/milan-morning.webp'),
  'Milan Day': require('./satta/milan-day.webp'),
  'Delhi Darbar': require('./satta/delhi-darbar.webp'),
  'MP Bazar': require('./satta/mp-bazar.webp'),
  Kuber: require('./satta/kuber.webp'),
};

// const SATTA_GAME_BG: Record<string, string> = {
//   Kalyan: 'https://download.indusmega.com/satta/bg/Kalyan.webp',
//   'Kalyan Night': 'https://download.indusmega.com/satta/bg/Kalyan_Night.webp',
//   'Milan Night': 'https://download.indusmega.com/satta/bg/Milan_Night.webp',
//   'Main Bazar': 'https://download.indusmega.com/satta/bg/Main_Bazar.webp',
//   'Mumbai Main': 'https://download.indusmega.com/satta/bg/Mumbai_Main.webp',
//   'Bengal Bazar': 'https://download.indusmega.com/satta/bg/Bengal_Bazar.webp',
//   Ratnagiri: 'https://download.indusmega.com/satta/bg/Ratnagiri.webp',
//   'Kalyan Morning':
//     'https://download.indusmega.com/satta/bg/Kalyan_Morning.webp',
//   'Milan Morning': 'https://download.indusmega.com/satta/bg/Milan_Morning.webp',
//   'Milan Day': 'https://download.indusmega.com/satta/bg/Milan_Day.webp',
//   'Delhi Darbar': 'https://download.indusmega.com/satta/bg/Delhi_Darbar.webp',
//   'MP Bazar': 'https://download.indusmega.com/satta/bg/MP_Bazar.webp',
//   Kuber: 'https://download.indusmega.com/satta/bg/Kuber.webp',
// };

const DIGIT_GAME_ICON: Record<string, ImageRequireSource> = {
  'Dear Lottery': require('./digit/dear.webp'),
  'Kerala Lottery': require('./digit/kerala.webp'),
  Skywin: require('./digit/sky-win.webp'),
  Lucwin: require('./digit/luc.webp'),
  GoldenJackpot: require('./digit/golden.webp'),
  KuberLottery: require('./digit/kuber.webp'),
  Chennailotto: require('./digit/chennai.webp'),
  bhutan: require('./digit/bhutan.webp'),
  quick: require('./digit/quick.webp'),
  Manipur: require('./digit/manipur.webp'),
  Mizoram: require('./digit/mizoram.webp'),
  Andaman: require('./digit/andaman.webp'),
  Assam: require('./digit/assam.webp'),
  'Arunachal Pradesh': require('./digit/arunachal-pradesh.webp'),
  Meghalaya: require('./digit/meghalaya.webp'),
  Sikkim: require('./digit/bhutan.webp'),
};

// const KERALA_IMAGES: Record<string, string> = {
//   AKSHAYA:
//     'https://download.indusmega.com/manager/92e6aa89acc04a4e99c9d3f4395079f2.webp',
//   'STHREE-SAKTHI':
//     'https://download.indusmega.com/manager/c3bc2a3505b64806ab630e2631434f08.webp',
//   KARUNYA:
//     'https://download.indusmega.com/manager/de74fa1b3f424d23979d6f51f8afdf74.webp',
//   NIRMAL:
//     'https://download.indusmega.com/manager/b23fd8ba499b43709cccaf4af51939b7.webp',
//   'KARUNYA PLUS':
//     'https://download.indusmega.com/manager/a44c5bbdbd9b4c5a9696839eb07d612d.webp',
//   'FIFTY-FIFTY':
//     'https://download.indusmega.com/manager/6c6d4ce2e79f437da2a1d2f72d2ff5f1.webp',
//   'WIN-WIN':
//     'https://download.indusmega.com/manager/c44264ca536849b1beb4f078d19f0d84.webp',
//   'ONLINE-ONLY':
//     'https://download.indusmega.com/manager/c3e0a9729b104b98a3065dfbddfe7806.webp',
// };

// const KERALA_IMAGES_LOGO: Record<string, string> = {
//   AKSHAYA: 'https://download.indusmega.com/kerala/order/akshaya.webp',
//   'STHREE-SAKTHI': 'https://download.indusmega.com/kerala/order/sthree.webp',
//   KARUNYA: 'https://download.indusmega.com/kerala/order/karunya.webp',
//   NIRMAL: 'https://download.indusmega.com/kerala/order/nirmal.webp',
//   'KARUNYA PLUS':
//     'https://download.indusmega.com/kerala/order/karunya_plus.webp',
//   'FIFTY-FIFTY': 'https://download.indusmega.com/kerala/order/fifty.webp',
//   'WIN-WIN': 'https://download.indusmega.com/kerala/order/win.webp',
//   'ONLINE-ONLY': 'https://download.indusmega.com/kerala/order/online.webp',
// };

export {
  DICE_GAME_ICON,
  COLOR_GAME_ICON,
  KERALA_GAME_ICON,
  SATTA_GAME_ICON,
  // SATTA_GAME_BG,
  DIGIT_GAME_ICON,
  // KERALA_IMAGES,
  // KERALA_IMAGES_LOGO,
};
